import { css } from '@emotion/css';
import type { GlobalToken } from 'antd';

/** The header row of a small table of named fields, shared by the label detail and the summary's specimens. */
export const fieldsTableHead = (token: GlobalToken) => css`
  th {
    padding: 0 ${token.marginLG}px ${token.paddingXXS}px 0;
    text-align: left;
    font-weight: 400;
    font-size: ${token.fontSizeSM}px;
    color: ${token.colorTextSecondary};
    border-bottom: 1px solid ${token.colorSplit};
    white-space: nowrap;
  }
`;
